import { useAuth } from "../auth/auth-provider/auth-provider";
import { useCallback, useEffect, useState, useMemo, Fragment, } from "react";

import { useOpenDrawer } from "../custom-providers/open-drawer-provider/open-drawer-provider";

import UserMenu from "./user-menu/user-menu";
import { Toolbar } from "devextreme-react";

import logo from './../../assets/logo/logo.jpg';
import { Link } from "react-router-dom";
import GetOfflineModeByCode from "../api-layer/offline-mode-api/GetOfflineModeByCode";
import { persianLanguage } from "../../constants/persianTerms";
import WebSocketService from "../../shared/websocketUtils";
import { WS_OFFLINE_MODE_API } from "../../constants/api";
import { consoleLog } from "../../shared/utils";

export default function MainNavbar(){
    const auth = useAuth();
    const {opened, setOpened} = useOpenDrawer();

    const [offlineMode, setOfflineMode] = useState(null);
    const offlineCSSClass = 'user-select-none g-red-100 text-red-700 m-1 px-4 py-1 rounded relative';
    const onlineCSSClass = 'user-select-none g-green-100 text-green-700 m-1 px-4 py-1 rounded relative';
    const [managerIsOfflineCSSClass, setManagerIsOfflineCSSClass] = useState(offlineCSSClass);
    const [isOfflineStatusText, setIsOfflineStatusText] = useState('');

    useEffect(() => {
        // console.log('auth in MainNavbar is: ', auth)
    }, [
        opened,
        auth?.token,
    ]);
   
    const toolbarItems = useMemo(() => [{
        widget: 'dxButton',
        location: 'before',
        options: {
          icon: 'menu',
          stylingMode: 'text',
          onClick: () => setOpened(!opened),
        },
    }], [opened, setOpened]);


  // useEffect(()=> {
  //   getOfflineMode();
  //   const intervalId = setInterval(getOfflineMode, 20000);
  //   return () => clearInterval(intervalId);
  // }, [
  // ])
      
  const getOfflineMode = () => {
      GetOfflineModeByCode('last').then(
          response => {
              setOfflineMode(response.data);
              changeManagerOfflineStatusCSSCLass(response.data);
          }
      ).catch(
          error => {
          }
      )
  }

  const changeManagerOfflineStatusCSSCLass = (data) => {
    if(data.isOffline){
      setManagerIsOfflineCSSClass(offlineCSSClass);
      setIsOfflineStatusText(persianLanguage.word.general.OFFLINE);
    }else{
      setManagerIsOfflineCSSClass(onlineCSSClass);
      setIsOfflineStatusText(persianLanguage.word.general.ONLINE);
    }
  }
  const getRealTimeOfflineMode = (data) => {
    const parsedData = JSON.parse(data);
    setOfflineMode(parsedData.message);
    changeManagerOfflineStatusCSSCLass(parsedData.message);
    consoleLog({'realtime offlinemode ': parsedData})
  }

  const realTimeOfflineModeError = (error) => {
  }

  const realTimeOfflineModeClosed = (event) => {
  }

  const wsOfflineModeUrl = `${WS_OFFLINE_MODE_API}?token=${auth.token}`;
  const offlineModeWSService = new WebSocketService(wsOfflineModeUrl,
    auth?.token,
    getRealTimeOfflineMode, 
    realTimeOfflineModeError, 
    realTimeOfflineModeClosed,
  );

    useEffect(() => {
      if(!auth?.token){
        return;
      }
      offlineModeWSService.connect();
      return () => {
          offlineModeWSService.disconnect();
    };
    }, [auth?.token]);



    if(auth?.token){
        return (
        <Fragment>
            <div className="columns-2" >
                <div className="flex flex-row">
                    <div>
                        <Link to={`/`}>
                            <img className=" mt-1 mx-3 logo" src={logo} alt="logo" />
                        </Link>

                    </div>
                    <div className="mx-2">
                        {/* <Toolbar position='right' items={toolbarItems} rtlEnabled={true} /> */}
                    </div>
                    {
                      offlineMode
                      &&
                      <div className="mt-1 mx-2">
                          <span className={`${managerIsOfflineCSSClass} text-[10px]`} >
                              {persianLanguage.word.general.MANAGER} {isOfflineStatusText}
                          </span>
                      </div>
                    }

                </div>
                <UserMenu />
            </div>
            <hr className="hr-style"/>
        </Fragment>
    );
    }
}